<template>
    <Transition>
        <div style="margin-right: 10px;" v-if="candidate">
        <div class="form container px-2">
        <h5><b>PERSONAL DATA</b></h5>
        <div class="mb-4 mt-3">
            <div>
                <p class="mb-0"><b>1. &nbsp; &nbsp;Name (Surname Last):</b></p>
            </div>
            <div>
                <input type="text" class="form-control pb-0" name="name" v-model="name" placeholder="e.g. John Doe">
            </div>
        </div>

        <div class="mb-4 text-start">
            <div>
                <p class="mb-0"><b>2. &nbsp; &nbsp;Category of Staff:</b></p>
            </div>
            <select v-model="staffType" id="staffType"
                name="Staff Type" @change="updateStaffType()" :disabled="candidate.submitted">
                <option selected value="Staff Type">Staff Type</option>
                <option value="Academic Teaching">Academic Teaching Staff</option>
                <option value="Research">Research Staff</option>
                <option value="Library">Library Staff</option>
                <option value="Senior Non-academic">Senior Non-academic Staff</option>
                <option value="Junior Non-academic">Junior Non-academic Staff</option>
            </select>
        </div>

        <div class="mb-4">
            <div>
                <p class="mb-0"><b>3. &nbsp; &nbsp;Staff Personal File Number:</b></p>
            </div>
            <div>
                <input type="text" class="form-control pb-0" name="fileNum" v-model="fileNum" placeholder="e.g. RSU/PF/SS/4226">
            </div>
        </div>

        <div class="mb-4">
            <div>
                <p class="mb-0"><b>4. &nbsp; &nbsp;Phone Number:</b></p>
            </div>
            <div>
                <input type="text" class="form-control pb-0" name="phoneNum" v-model="phoneNum" placeholder="e.g. 08012345678">
            </div>
        </div>

        <div class="mb-4">
            <div>
                <p class="mb-0"><b>5. &nbsp; &nbsp;Faculty/Institute/Directorate/Center:</b></p>
            </div>
            <select id="faculty" name="faculty" v-model="faculty" :disabled="candidate.submitted">
                <option value="faculty">Please select</option>
                <option value="Agriculture" selected>Agriculture</option>
                <option value="Basic Medical Sciences">Basic Medical Sciences</option>
                <option value="Basic Clinical Sciences">Basic Clinical Sciences</option>
                <option value="Clinical Sciences">Clinical Sciences</option>
                <option value="Medical Laboratory Science">Medical Laboratory Science</option>
                <option value="Communication and Media Studies">Communication and Media Studies</option>
                <option value="Engineering">Engineering</option>
                <option value="Education">Education</option>
                <option value="Environmental Sciences">Environmental Sciences</option>
                <option value="Humanities">Humanities</option>
                <option value="Law">Law</option>
                <option value="Administration and Management">Administration and Management</option>
                <option value="Science">Science</option>
                <option value="Insitute of Education">Institute of Education</option>
                <option value="Rivers Institute of Agricultural Research & Training">Rivers Institute of Agricultural Research & Training</option>
                <option value="Centre for Open and Distance Learning">Centre for Open and Distance Learning</option>
                <option value="Institute Of Geo-sciences And Environmental Management">Institute Of Geo-sciences And Environmental Management</option>
                <option value="Institute of Pollution Studies">Institute of Pollution Studies</option>
                <option value="Centre for Climate Change & Forest Resources">Social Sciences</option>
                <option value="Centre for Advance Law Research">Centre for Advance Law Research</option>
                <option value="Centre for Water & Sanitation Studies">Centre for Water & Sanitation Studies</option>
                <option value="Advancement and Linkage Centre profile">Advancement and Linkage Centre profile</option>
                <option value="Centre for Continuing Education">Centre for Continuing Education</option>
                <option value="Centre Of Excellence In Marine Offshore Engineering">Centre Of Excellence In Marine Offshore Engineering</option>
                <option value="Information and Communication Technology Centre (ICTC)">Information and Communication Technology Centre (ICTC)</option>
                <option value="Directorate of Alumni Relations">Directorate of Alumni Relations</option>
                <option value="Directorate of Physical Planning">Directorate of Physical Planning</option>
                <option value="Directorate of Research and Development">Directorate of Research and Development</option>
                <option value="Directorate of Pre-Degree Programme">Directorate of Pre-Degree Programme</option>
                <option value="Directorate of Establishment">Directorate of Establishment</option>
                <option value="Directorate of Students Affairs">Directorate of Students Affairs</option>
                <option value="Directorate of Quality Assurance">Directorate of Quality Assurance</option>
                <option value="Directorate of Academic Planning">Directorate of Academic Planning</option>
                <option value="University Library">University Library</option>
                <option value="Consultancy Services Unit">Consultancy Services Unit</option>
                <option value="Guidiance and Counselling Unit">Social Sciences</option>
                <option value="Foundation Studies Unit">Foundation Studies Unit</option>
                <option value="Medical Centre">Medical Centre</option>
                <option value="Information/Publication/Protocol Unit">Information/Publication/Protocol Unit</option>
                <option value="Intellectual Property and Technology Transfer Office">Intellectual Property and Technology Transfer Office</option>
                <option value="The Registry">The Registry</option>
                <option value="Students' Industrial Work Experience Scheme (SIWES) Unit">Students' Industrial Work Experience Scheme (SIWES) Unit</option>
                <option value="University Security Unit">University Security Unit</option>
                <option value="Estate, Works and Transport">Estate, Works and Transport</option>
                <option value="Others">Others</option>
            </select>
        </div>

        <div class="mb-4">
            <div>
                <p class="mb-0"><b>6. &nbsp; &nbsp;Cadre of Staff:</b></p>
            </div>
            <div class=" text-start">
                <div>
                    <select v-if="staffType == 'Senior Non-academic'" id="staffCadre" name="staffCadre" v-model="staffCadre"
                        style="width: 350px;" :disabled="candidate.submitted">
                        <option value="Registry" selected>Registry - Administrative Officers Cadre</option>
                        <option value="Executive">Executive Officers Cadre</option>
                        <option value="Sec">Secretaries Cadre</option>
                        <option value="Info">Information and Public Relations Officers Cadre</option>
                        <option value="Legal">Legal Officers Cadre</option>
                        <option value="Secretarial">Secretarial Assistant/Data processing Officer Cadre</option>
                        <option value="Pharmacists">Pharmacists Cadre</option>
                        <option value="Nursing">Nursing Cadre</option>
                        <option value="Medical">Medical Doctor's Cadre</option>
                        <option value="Health">Health Technician's Cadre</option>
                        <option value="Radiographer">Radiographer's Cadre</option>
                        <option value="Bursary">Bursary Staff - Accountant's Cadre</option>
                        <option value="Executive Accounts">Executive Officers (Accounts) Cadre</option>
                        <option value="Internal">Internal Auditor's Cadre</option>
                        <option value="Stores">Stores Cadre</option>
                        <option value="Security">Security Officer Cadre</option>
                        <option value="Library">Library (Sub-Professional Staff) Cadre</option>
                        <option value="Bindery">Bindery Staff Cadre</option>
                        <option value="Teaching Farm">Teaching Farm Officers Cadre</option>
                        <option value="Premises">Premises/Housekeepers Cadre</option>
                        <option value="Catering">Catering Officers Cadre</option>
                        <option value="Computer">Computer Professional Cadre</option>
                        <option value="Teacher">Teachers Cadre</option>
                        <option value="Technologist">Technologist Cadre</option>
                        <option value="Lab">Laboratory Scientist Cadre</option>
                        <option value="Sports">Sports Cadre</option>
                        <option value="Estate">Estate, Works & Transport (Engineers) Cadre</option>
                        <option value="Maintenance">Maintenance Officers/Other Professionals Cadre</option>
                        <option value="Technician">Technician Cadre (Technical Officers)</option>
                        <option value="Motor">Motor/Tractor Drivers and Mechanics Cadre</option>
                        <option value="Environmental">Environmental/Public Health Officer/Community Health Education Worker
                            Cadre</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic'" id="staffCadre" name="staffCadre" v-model="staffCadre"
                        style="width: 350px;" :disabled="candidate.submitted">
                        <option value="Registry" selected>Registry Department (Clerical Cadre)</option>
                        <option value="Cleaner">Cleaner Cadre</option>
                        <option value="Secretarial">Secretarial Assistants (i.e. Typists) Cadre</option>
                        <option value="Computer">Computer Operator Cadre</option>
                        <option value="Audit">Audit Cadre</option>
                        <option value="Store">Store Cadre</option>
                        <option value="Accounts">Accounts Cadre</option>
                        <option value="Catering">Catering Cadre</option>
                        <option value="Halls">Halls of Residence</option>
                        <option value="Health">Health Services Department (Medical Records Cadre)</option>
                        <option value="Pharmacy">Pharmacy Assistant Cadre</option>
                        <option value="Health Assistant">Health Assitant Cadre</option>
                        <option value="Washerman">Washerman Cadre</option>
                        <option value="Library">Library Department</option>
                        <option value="Bindery">Bindery/Printing Cadre</option>
                        <option value="Audio">Audio-Visual Cadre</option>
                        <option value="Security">Security Department</option>
                        <option value="Environmental">Environmental Sciences (Technical Cadre)</option>
                        <option value="Engineering">Engineering, Science (Technical Cadre)</option>
                        <option value="Marine">Marine Engineering Department (Technician Cadre)</option>
                        <option value="Estate">Estate, Works and Transport Department (Labour/Gardener) Cadre</option>
                        <option value="Technical">Technical Cadre</option>
                        <option value="Drivers">Drivers Cadre</option>
                        <option value="Divers Mate">Drivers Mate Cadre</option>
                        <option value="Tractor">Tractor Drivers' Cadre</option>
                        <option value="Tractor Mate">Tractor Drivers' Mate Cadre</option>
                        <option value="Stores">Stores Cadre (Estate, Works and Transport Department)</option>
                        <option value="Store Attendant">Store Attendant (Estate, Works and Transport Department)</option>
                        <option value="Agriculture">Faculty of Agriculture (Technical Cadre)</option>
                        <option value="Labourer">Labourer Cadre (Faculty of Agriculture)</option>
                        <option value="Science">Science Laboratory Cadre</option>
                        <option value="Nursery">Nursery Attendants for the Staff School</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="mb-4" v-if="staffType == 'Senior Non-academic'">
            <div>
                <p class="mb-0"><b>7. &nbsp; &nbsp;Present status, grade level, and salary:</b></p>
            </div>
            <div class="text-start">
                <div>
                    <div class="mt-2" v-if="staffCadre == ''">Please select a Cadre in 4 above.</div>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Registry'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Admin 2" selected>Administrative Officer II (CONTISS 7)</option>
                        <option value="Admin 1">Administrative Officer I (CONTISS 8)</option>
                        <option value="Assistant Registrar">Assistant Registrar (CONTISS 9)</option>
                        <option value="Senior Assistant Registrar">Senior Assistant Registrar (CONTISS 11)</option>
                        <option value="Principal Assistant Registrar">Principal Assistant Registrar (CONTISS 13)</option>
                        <option value="Deputy Registrar">Deputy Registrar (CONTISS 14)</option>
                        <option value="Director">Director (CONTISS 15)</option>
                        <option value="Registrar">Registrar (CONTISS 15)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Executive'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Exec" selected>Executive Officer (CONTISS 6)</option>
                        <option value="Higher Exec">Higher Executive Officer (CONTISS 7)</option>
                        <option value="Senior Exec">Senior Executive Officer (CONTISS 8)</option>
                        <option value="Principal Exec">Principal Executive Officer (CONTISS 9)</option>
                        <option value="Assist Chief Exec">Assist. Chief Executive Officer (CONTISS 11)</option>
                        <option value="Deputy Chief Exec">Deputy Chief Executive Officer (CONTISS 12)</option>
                        <option value="Chief Exec 2">Chief Executive Officer II (CONTISS 13)</option>
                        <option value="Chief Exec 1">Chief Executive Officer I (CONTISS 14)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Sec'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Conf Sec 2" selected>Confidential Secretary II (CONTISS 6)</option>
                        <option value="Conf Sec 1">Confidential Secretary I (CONTISS 7)</option>
                        <option value="Snr Conf Sec">Senior Confidential Secretary (CONTISS 8)</option>
                        <option value="Principal Conf Sec 2">Principal Confidential Secretary II (CONTISS 9)</option>
                        <option value="Principal Conf Sec 1">Principal Confidential Secretary I (CONTISS 11)</option>
                        <option value="Assist Chief Conf Sec">Assist. Chief Confidential Secretary (CONTISS 12)</option>
                        <option value="Deputy Chief Conf Sec">Deputy Chief Confidential Secretary (CONTISS 13)</option>
                        <option value="Chief Conf Sec">Chief Confidential Secretary (CONTISS 14)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Info'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Info 2" selected>Information Officer II (CONTISS 7)</option>
                        <option value="Info 1">Information Officer I (CONTISS 8)</option>
                        <option value="Snr Info">Senior Information Officer (CONTISS 9)</option>
                        <option value="Principal Info">Principal Information Officer (CONTISS 11)</option>
                        <option value="Assist Chief Info">Assistant Chief Information Officer (CONTISS 12)</option>
                        <option value="PRO">Public Relations Officer (CONTISS 13)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Legal'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Legal" selected>Legal Officer (CONTISS 8)</option>
                        <option value="Snr Legal">Senior Legal Officer (CONTISS 9)</option>
                        <option value="Principal Legal">Principal Legal Officer (CONTISS 11)</option>
                        <option value="Assist Chief Legal Officer">Assistant Chief Legal Officer (CONTISS 12)</option>
                        <option value="Deputy Chief Legal Officer">Deputy Chief Legal Officer (CONTISS 13)</option>
                        <option value="Chief Legal Officer">Assist. Chief Confidential Secretary (CONTISS 14)</option>
                        <option value="Legal Services Director">Director of Legal Services (CONTISS 15)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Secretarial'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Snr Sec Assist 2" selected>Senior Secretarial Assistant II/Data Processing Officer
                            (CONTISS 6)</option>
                        <option value="Snr Sec Assist 1">Senior Secretarial Assistant I/Higher Data Processing Officer
                            (CONTISS 7)</option>
                        <option value="Chief Sec Assist">Chief Secretarial Assistant/Senior Data Processing Officer (CONTISS
                            8)</option>
                        <option value="Principal Data Proc 2">Principal Data Processing Officer II (CONTISS 9)</option>
                        <option value="Principal Data Proc 1">Principal Data Processing Officer I (CONTISS 11)</option>
                        <option value="Assist Chief Data Proc">Assistant Chief Data Processing Officer (CONTISS 12)</option>
                        <option value="Chief Data Proc">Chief Data Processing Officer (CONTISS 13)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Pharmacists'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Pharm" selected>Pharmacist (CONTISS 8)</option>
                        <option value="Snr Pharm">Senior Pharmacist (CONTISS 9)</option>
                        <option value="Principal Pharm">Principal Pharmacist (CONTISS 11)</option>
                        <option value="Assist Chief Pharm">Assistant Chief Pharmacist (CONTISS 12)</option>
                        <option value="Deputy Chief Pharm">Deputy Chief Pharmacist (CONTISS 13)</option>
                        <option value="Chief Pharm">Assistant Chief Data Processing Officer (CONTISS 14)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Nursing'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Nurse 2" selected>Staff Nurse 2 (CONTISS 6)</option>
                        <option value="Midwife 2">Staff Midwife 2 (CONTISS 6)</option>
                        <option value="Nurse/Midwife 2">Staff Nurse/Midwife 2 (CONTISS 6)</option>
                        <option value="Nurse 1">Staff Nurse 1 (CONTISS 7)</option>
                        <option value="Midwife 1">Staff Midwife 1 (CONTISS 7)</option>
                        <option value="Nurse/Midwife 1">Staff Nurse/Midwife 1 (CONTISS 7)</option>
                        <option value="Nursing">Nursing Officer (CONTISS 8)</option>
                        <option value="Snr Nursing">Senior Nursing Officer (CONTISS 9)</option>
                        <option value="Snr Nursing Supt.">Senior Nursing Supt. (CONTISS 9)</option>
                        <option value="Snr Health Officer">Senior Health Officer (CONTISS 9)</option>
                        <option value="Snr Health Visitor">Senior Health Visitor (CONTISS 9)</option>
                        <option value="Matron">Matron (CONTISS 11)</option>
                        <option value="Principal/Health">Principal/Health Officer (CONTISS 11)</option>
                        <option value="Principal Nursing">Principal Nursing (CONTISS 11)</option>
                        <option value="Snr Matron">Senior Matron (CONTISS 12)</option>
                        <option value="Assist Chief Health">Assistant Chief Health Officer (CONTISS 12)</option>
                        <option value="Assist Chief Health Supt.">Assistant Chief Health Supt. (CONTISS 12)</option>
                        <option value="Assist Chief Nursing Supt.">Assistant Chief Nursing Supt. (CONTISS 12)</option>
                        <option value="Chief Matron">Chief Matron (CONTISS 13)</option>
                        <option value="Chief Nursing">Chief Nursing Officer (CONTISS 13)</option>
                        <option value="Chief Nursing Supt.">Chief Nursing Supt. (CONTISS 13)</option>
                        <option value="Chief Health Supt.">Chief Health Supt. (CONTISS 13)</option>
                        <option value="Chief Health Officer">Chief Health Officer (CONTISS 13)</option>
                        <option value="Chief Nursing Officer in-charge">Chief Nursing Officer in-charge (CONTISS 14)
                        </option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Medical'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Med" selected>Medical Officer/Registrar (CONTISS 9)</option>
                        <option value="Snr Med 2">Senior Medical Officer II/Senior Registrar II (CONTISS 11)</option>
                        <option value="Snr Med 1">Senior Medical Officer I/Senior Registrar I (CONTISS 12)</option>
                        <option value="Principal Med 2">Principal Medical Officer II (CONTISS 13)</option>
                        <option value="Principal Med 1">Principal Medical Officer I (CONTISS 14)</option>
                        <option value="Chief Med">Chief Medical Officer (CONTISS 15)</option>
                        <option value="Health Services Director">Director of Health Services (CONTISS 15)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Health'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Comm Health Tech" selected>Community Health Technician (CONTISS 6)</option>
                        <option value="Pharm Tech">Pharmacy Technician (CONTISS 6)</option>
                        <option value="Med Lab Tech">Medical Laboratory Technician (CONTISS 6)</option>
                        <option value="Med Rec Tech">Medical Records Technician (CONTISS 6)</option>
                        <option value="X-ray Tech">X-ray Technician (CONTISS 6)</option>
                        <option value="Higher Comm Health Tech">Higher Community Health Technician (CONTISS 7)</option>
                        <option value="Higher Pharm Tech">Higher Pharmacy Technician (CONTISS 7)</option>
                        <option value="Higher Med Lab Tech">Higher Medical Laboratory Technician (CONTISS 7)</option>
                        <option value="Higher Med Rec Tech">Higher Medical Records Technician (CONTISS 7)</option>
                        <option value="Higher X-ray Tech">Higher X-ray Technician (CONTISS 7)</option>
                        <option value="Snr Comm Health Tech">Senior Community Health Technician (CONTISS 8)</option>
                        <option value="Snr Pharm Tech">Senior Pharmacy Technician (CONTISS 8)</option>
                        <option value="Snr Med Lab Tech">Senior Medical Laboratory Technician (CONTISS 8)</option>
                        <option value="Snr Med Rec Tech">Senior Medical Records Technician (CONTISS 8)</option>
                        <option value="Snr X-ray Tech">Senior X-ray Technician (CONTISS 8)</option>
                        <option value="Principal Comm Health Tech">Principal Community Health Technician (CONTISS 9)
                        </option>
                        <option value="Principal Pharm Tech">Principal Pharmacy Technician (CONTISS 9)</option>
                        <option value="Principal Med Lab Tech">Principal Medical Laboratory Technician (CONTISS 9)</option>
                        <option value="Principal Med Rec Tech">Principal Medical Records Technician (CONTISS 9)</option>
                        <option value="Principal X-ray Tech">Principal X-ray Technician (CONTISS 9)</option>
                        <option value="Assist Chief Comm Health Tech">Assistant Chief Community Health Technician (CONTISS
                            11)
                        </option>
                        <option value="Assist Chief Pharm Tech">Assistant Chief Pharmacy Technician (CONTISS 11)</option>
                        <option value="Assist Chief Med Lab Tech">Assistant Chief Medical Laboratory Technician (CONTISS 11)
                        </option>
                        <option value="Assist Chief Rec Tech">Assistant Chief Medical Records Technician (CONTISS 11)
                        </option>
                        <option value="Assist Chief X-ray Tech">Assistant Chief X-ray Technician (CONTISS 11)</option>
                        <option value="Chief Comm Health Tech">Chief Community Health Technician (CONTISS
                            12)
                        </option>
                        <option value="Chief Pharm Tech">Chief Pharmacy Technician (CONTISS 12)</option>
                        <option value="Chief Med Lab Tech">Chief Medical Laboratory Technician (CONTISS 12)
                        </option>
                        <option value="Chief Rec Tech">Chief Medical Records Technician (CONTISS 12)
                        </option>
                        <option value="Chief X-ray Tech">Chief X-ray Technician (CONTISS 12)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Radiographer'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Radio">Radiographer (CONTISS 8)
                        </option>
                        <option value="Snr Radio">Senior Radiographer (CONTISS 9)</option>
                        <option value="Principal Radio">Principal Radiographer (CONTISS 11)
                        </option>
                        <option value="Assist Chief Radio">Assistant Chief Radiographer (CONTISS 12)
                        </option>
                        <option value="Chief Radio">Chief Radiographer (CONTISS 13)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Bursary'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Accountant 2">Accountant II (CONTISS 7)</option>
                        <option value="Accountant 1">Accountant I (CONTISS 8)</option>
                        <option value="Snr Accountant">Senior Accountant (CONTISS 9)</option>
                        <option value="Principal Accountant">Principal Accountant (CONTISS 11)</option>
                        <option value="Chief Accountant">Chief Accountant (CONTISS 13)</option>
                        <option value="Deputy Bursar">Deputy Bursar (CONTISS 14)</option>
                        <option value="Bursar">Bursar (CONTISS 15)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Executive Accounts'"
                        id="presentStatus" name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Exec">Executive Officer (Accounts) (CONTISS 6)</option>
                        <option value="Higher Exec">Higher Executive Officer (Accounts) (CONTISS 7)</option>
                        <option value="Senior Exec">Senior Executive Officer (Accounts) (CONTISS 8)</option>
                        <option value="Principal Exec">Principal Executive Officer (Accounts) (CONTISS 9)</option>
                        <option value="Assist Chief Exec">Assistant Chief Executive Officer (Accounts) (CONTISS 11)</option>
                        <option value="Deputy Chief Exec">Deputy Chief Executive Officer (Accounts) (CONTISS 12)</option>
                        <option value="Chief Exec 2">Chief Executive Officer II (Accounts) (CONTISS 13)</option>
                        <option value="Chief Exec 1">Chief Executive Officer I (CONTISS 14)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Internal'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Internal Auditor 2">Internal Auditor Grade II (CONTISS 7)</option>
                        <option value="Internal Auditor 1">Internal Auditor Grade I (CONTISS 8)</option>
                        <option value="Snr Internal Auditor">Senior Internal Auditor (CONTISS 9)</option>
                        <option value="Principal Internal Auditor">Principal Internal Auditor (CONTISS 11)</option>
                        <option value="Chief Internal Auditor">Chief Internal Auditor (CONTISS 13)</option>
                        <option value="Deputy Audit Director">Deputy Director of Audit (CONTISS 14)</option>
                        <option value="Audit Director">Director of Audit (CONTISS 15)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Stores'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Stores">Stores Officer (CONTISS 6)</option>
                        <option value="Higher Stores">Higher Stores Officer (CONTISS 7)</option>
                        <option value="Snr Stores">Senior Stores Officer (CONTISS 8)</option>
                        <option value="Principal Stores">Principal Stores Officer (CONTISS 9)</option>
                        <option value="Assist Chief Stores">Assistant Chief Stores Officer (CONTISS 11)</option>
                        <option value="Deputy Chief Stores">Deputy Chief Stores Officer (CONTISS 12)</option>
                        <option value="Chief Stores">Chief Stores Officer (CONTISS 13)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Security'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Assist Security">Assistant Security Officer (CONTISS 6)</option>
                        <option value="Security">Security Officer (CONTISS 7)</option>
                        <option value="Snr Security">Senior Security Officer (CONTISS 8)</option>
                        <option value="Principal Security">Principal Security Officer (CONTISS 9)</option>
                        <option value="Assist Chief Security">Assistant Chief Security Officer (CONTISS 11)</option>
                        <option value="Deputy Chief Security">Deputy Chief Security Officer (CONTISS 12)</option>
                        <option value="Chief Security">Chief Security Officer (CONTISS 13)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Library'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Library">Library Officer (CONTISS 6)</option>
                        <option value="Higher Library">Higher Library Officer (CONTISS 7)</option>
                        <option value="Snr Library">Senior Library Officer (CONTISS 8)</option>
                        <option value="Principal Library">Principal Library Officer (CONTISS 9)</option>
                        <option value="Assist Chief Library">Assistant Chief Library Officer (CONTISS 11)</option>
                        <option value="Deputy Chief Library">Deputy Chief Library Officer (CONTISS 12)</option>
                        <option value="Chief Library">Chief Library Officer (CONTISS 13)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Bindery'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Bindery">Bindery Officer (CONTISS 6)</option>
                        <option value="Higher Bindery">Higher Bindery Officer (CONTISS 7)</option>
                        <option value="Snr Bindery">Senior Bindery Officer/Senior Superintendent of Bindery (CONTISS 8)
                        </option>
                        <option value="Principal Bindery 2">Principal Bindery Officer II/Principal Superintendent of Bindery
                            II (CONTISS 9)</option>
                        <option value="Principal Bindery 1">Principal Bindery Officer I/Principal Superintendent of Bindery
                            I (CONTISS 11)</option>
                        <option value="Assist Chief Bindery">Assistant Chief Bindery Officer/Assistant Chief Superintendent
                            of Bindery (CONTISS 12)</option>
                        <option value="Deputy Chief Bindery">Deputy Chief Bindery Officer/Deputy Chief Superintendent of
                            Bindery (CONTISS 13)</option>
                        <option value="Chief Bindery">Chief Bindery Officer (CONTISS 14)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Teaching Farm'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Farm 2">Farm Officer II (CONTISS 7)</option>
                        <option value="Farm 1">Farm Officer I (CONTISS 8)</option>
                        <option value="Snr Farm">Senior Farm Officer (CONTISS 9)</option>
                        <option value="Principal Farm">Principal Farm Officer (CONTISS 11)</option>
                        <option value="Deputy Chief Farm">Deputy Chief Farm Officer (CONTISS 13)</option>
                        <option value="Chief Farm">Chief Farm Officer (CONTISS 14)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Premises'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Premises">Premises Officer/House Keeper (CONTISS 6)</option>
                        <option value="Higher Premises">Higher Premises Officer/Higher House Keeper (CONTISS 7)</option>
                        <option value="Snr Premises">Senior Premises Officer/Senior House Keeper (CONTISS 8)</option>
                        <option value="Principal Premises">Principal Premises Officer/Principal House Keeper (CONTISS 9)
                        </option>
                        <option value="Assist Chief Premises">Assistant Chief Premises Officer (CONTISS 11)</option>
                        <option value="Deputy Chief Premises">Deputy Chief Premises Officer (CONTISS 12)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Catering'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Catering">Catering Officer (CONTISS 6)</option>
                        <option value="Higher Catering">Higher Catering Officer (CONTISS 7)</option>
                        <option value="Snr Catering">Senior Catering Officer (CONTISS 8)</option>
                        <option value="Principal Catering">Principal Catering Officer (CONTISS 9)</option>
                        <option value="Assist Chief Catering">Assistant Chief Catering Officer (CONTISS 11)</option>
                        <option value="Deputy Chief Catering">Deputy Chief Catering Officer (CONTISS 12)</option>
                        <option value="Chief Catering">Chief Catering Officer (CONTISS 13)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Computer'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Data">Data Officer (CONTISS 6)</option>
                        <option value="Systems Analyst 2">Systems Analyst/Programmer II; Systems Engineer II; Technologist
                            II
                            (CONTISS 7)</option>
                        <option value="Systems Analyst 1">Systems Analyst/Programmer I; Systems Engineer I; Technologist I
                            (CONTISS 8)
                        </option>
                        <option value="Snr Systems Analyst">Senior Systems Analyst/Programmer; Systems Engineer Senior
                            Technologist (CONTISS 9)</option>
                        <option value="Principal Systems Analyst">Principal Systems Analyst/Progammer; Principal Systems
                            Engineer (CONTISS 11)</option>
                        <option value="Assist Chief Systems Analyst">Assistant Chief Systems Analyst/Progammer; Assitant
                            Chief Systems Engineer; Assitant Chief Technlogist (CONTISS 12)</option>
                        <option value="Deputy Chief Systems Analyst">Deputy Chief Systems Analyst/Programmer; Deputy Chief
                            Systems
                            Engineer; Deputy Chief Technologist (CONTISS 13)</option>
                        <option value="Chief Systems Analyst">Chief Systems Analyst/Programmer; Chief Systems Engineer;
                            Chief Technologist (CONTISS 14)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Teacher'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Master 3">Master Grade III (CONTISS 6)</option>
                        <option value="Master 2">Master Grade II (CONTISS 7)</option>
                        <option value="Master 1">Master Grade I (CONTISS 8)</option>
                        <option value="Snr Master 2">Senior Master Grade II (CONTISS 9)</option>
                        <option value="Snr Master 1">Senior Master Grade I (CONTISS 11)</option>
                        <option value="Principal Master">Principal Master (CONTISS 12)</option>
                        <option value="Chief Master">Chief Master (CONTISS 13)</option>
                        <option value="Head Master">Principal/Headmaster/Head mistress (CONTISS 14)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Technologist'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Tech 2">Technologist II (CONTISS 7)</option>
                        <option value="Tech 1">Technologist I (CONTISS 8)</option>
                        <option value="Senior Tech">Senior Technologist (CONTISS 9)</option>
                        <option value="Principal Tech">Principal Technologist II (CONTISS 11)</option>
                        <option value="Assist Chief Tech">Asistant Chief Technologist (CONTISS 12)</option>
                        <option value="Chief Tech">Chief Technologist (CONTISS 13)</option>
                        <option value="Senior Chief Tech">Senior Chief Technologist (CONTISS 14)</option>
                        <option value="Principal Chief Tech">Principal Chief Technologist (CONTISS 15)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Lab'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Lab 2">Laboratory Scientist II (CONTISS 7)</option>
                        <option value="Lab 1">Laboratory Scientist I (CONTISS 8)</option>
                        <option value="Senior Lab">Senior Laboratory Scientist (CONTISS 9)</option>
                        <option value="Principal Lab">Principal Laboratory Scientist II (CONTISS 11)</option>
                        <option value="Assist Chief Lab">Asistant Chief Laboratory Scientist (CONTISS 12)</option>
                        <option value="Chief Lab">Chief Laboratory Scientist (CONTISS 13)</option>
                        <option value="Senior Chief Lab">Senior Chief Laboratory Scientist (CONTISS 14)</option>
                        <option value="Principal Chief Lab">Principal Chief Laboratory Scientist (CONTISS 15)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Sports'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Assist Coach">Assistant Coach (CONTISS 6)</option>
                        <option value="Coach 2">Coach Grade II (CONTISS 7)</option>
                        <option value="Coach 1">Coach Grade I (CONTISS 8)</option>
                        <option value="Snr Coach">Senior Coach (CONTISS 9)</option>
                        <option value="Principal Coach">Principal Coach (CONTISS 11)</option>
                        <option value="Chief Coach">Chief Coach (CONTISS 12)</option>
                        <option value="Assist DOS">Assistant Director of Sports (CONTISS 13)</option>
                        <option value="Deputy DOS">Deputy Director of Sports (CONTISS 14)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Estate'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Engr 2">Engineer II (CONTISS 7)</option>
                        <option value="Engr 1">Engineer I (CONTISS 8)</option>
                        <option value="Snr Engr">Senior Engineer (CONTISS 9)</option>
                        <option value="Principal Engr">Principal Engineer (CONTISS 11)</option>
                        <option value="Chief Engr">Chief Engineer (CONTISS 13)</option>
                        <option value="Deputy Director">Deputy Director of Civil/Mechanical/Electrical Engineering (CONTISS
                            14)</option>
                        <option value="DOW">Director of Works (CONTISS 15)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Maintenance'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Maint 2">Maintenance Officer II/Quantity Surveyor II/Architect II/Estate
                            Manager II (CONTISS 7)</option>
                        <option value="Maint 1">Maintenance Officer I/Quantity Surveyor I/Architect I/Estate Manager
                            I (CONTISS 8)</option>
                        <option value="Snr Maint">Senior Maintenance Officer/Quantity Surveyor/Architect/Estate Manager
                            (CONTISS 9)</option>
                        <option value="Principal Maint">Principal Maintenance Officer/Quantity Surveyor/Architect/Estate
                            Manager (CONTISS 11)</option>
                        <option value="Assist Chief Maint">Assistant Chief Maintenance Officer/Quantity
                            Surveyor/Architect/Estate Manager (CONTISS 12)</option>
                        <option value="Chief Maint">Chief Maintenance Officer/Quantity Surveyor/Architect/Estate Manager
                            (CONTISS
                            13)</option>
                        <option value="Assist DOM">Assistant Director of Maintenance/Quantity Surveying/Architecture/Estate
                            Manager (CONTISS 14)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Technician'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Techn">Technical Officer (CONTISS 6)</option>
                        <option value="Higher Techn">Higher Technical Officer (CONTISS 7)</option>
                        <option value="Snr Techn">Senior Technical Officer (STO) (CONTISS 8)</option>
                        <option value="Principal Techn 2">Principal Technical Officer II (CONTISS 9)</option>
                        <option value="Principal Techn">Principal Technical Officer (CONTISS 11)</option>
                        <option value="Assist CTO">Assistant Chief Technical Officer(CONTISS 12)</option>
                        <option value="CTO">Chief Technical Officer (CONTISS 13)</option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Motor'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Trans">Transport Supervisor/Workshop (Mechanic or Plant) (CONTISS 6)</option>
                        <option value="Snr Trans">Senior Transport Supervisor/Senior Workshop (Mechanic or Plant) (CONTISS
                            7)</option>
                        <option value="Principal Trans">Principal Transport Supervisor/Principal Workshop (Mechanic or
                            Plant)
                            (CONTISS 8)</option>
                        <option value="Assist CTS 2">Assistant Chief Transport Supervisor II/Assitant Chief Workshop II
                            (Mechanic or Plant) (CONTISS 9)</option>
                        <option value="Assist CTS">Assistant Chief Transport Supervisor/Assitant Chief Workshop (Mechanic or
                            Plant) (CONTISS 11)</option>
                        <option value="Deputy CTS">Deputy Chief Transport Supervisor/Deputy Chief Workshop (Mechanic or
                            Plant) (CONTISS 12)</option>
                        <option value="CTS">Chief Transport Supervisor/Chief Workshop (Mechanic or Plant) (CONTISS 13)
                        </option>
                    </select>
                    <select v-if="staffType == 'Senior Non-academic' && staffCadre == 'Environmental'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Env">Environmental/Public Health Officer (CONTISS 7)</option>
                        <option value="Higher Env">Higher Environmental/Public Health Officer (CONTISS 8)</option>
                        <option value="Snr Env">Senior Environmental/Public Health Officer (CONTISS 9)</option>
                        <option value="Principal Env">Principal Environmental/Public Health Officer (CONTISS 11)</option>
                        <option value="Assist Chief Env">Assistant Chief Environmental/Public Health Officer (CONTISS 12)
                        </option>
                        <option value="Chief Env">Chief Environmental/Public Health Officer (CONTISS 13)</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="mb-4" v-if="staffType == 'Junior Non-academic'">
            <div>
                <p class="mb-0"><b>7. &nbsp; &nbsp;Present status, grade level, and salary:</b></p>
            </div>
            <div class="text-start">
                <div>
                    <div class="mt-2" v-if="staffCadre == ''">Please select a Cadre in 4 above.</div>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Registry'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Exec Officer" selected>Executive Officer (CONTISS 6)</option>
                        <option value="Asst Exec Officer">Assistant Executive Officer (CONTISS 5)</option>
                        <option value="Senior Clerical">Senior Clerical Officer (CONTISS 4)</option>
                        <option value="Clerical">Clerical Officer (CONTISS 3)</option>
                        <option value="Clerical Assist">Clerical Assistant (CONTISS 2)</option>
                        <option value="Head Msg">Head Messenger (CONTISS 3)</option>
                        <option value="Msg 1">Messenger I (CONTISS 2)</option>
                        <option value="Msg 2">Messenger II (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Cleaner'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Head Cleaner" selected>Head Cleaner (CONTISS 3)</option>
                        <option value="Cleaner 1">Cleaner I (CONTISS 2)</option>
                        <option value="Cleaner 2">Cleaner II (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Secretarial'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Snr Sec Assist 2" selected>Senior Secretarial Assistant II (CONTISS 6)</option>
                        <option value="Sec Assist 1">Secretarial Assistant I (CONTISS 5)</option>
                        <option value="Sec Assist 2">Secretarial Assistant II (CONTISS 4)</option>
                        <option value="Sec Assist 3">Secretarial Assistant III (CONTISS 3)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Computer'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Data" selected>Data Officer (CONTISS 6)</option>
                        <option value="Head Comp Op">Head Computer Operator (CONTISS 5)</option>
                        <option value="Snr Comp Op">Senior Computer Operator (CONTISS 4)</option>
                        <option value="Comp Op">Computer Operator (CONTISS 3)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Audit'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Exec Audit" selected>Executive Officer (Audit) (CONTISS 6)</option>
                        <option value="Asst Exec Audit">Assistant Executive Officer (Audit) (CONTISS 5)</option>
                        <option value="Snr Audit">Senior Audit Clerk (CONTISS 4)</option>
                        <option value="Audit">Audit Clerk (CONTISS 3)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Store'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Stores" selected>Stores Officer (CONTISS 6)</option>
                        <option value="Store Keep 1">Store Keeper I (CONTISS 5)</option>
                        <option value="Store Keep 2">Store Keeper II (CONTISS 4)</option>
                        <option value="Store Clerk">Store Clerk (CONTISS 3)</option>
                        <option value="Store Asst">Store Assistant (CONTISS 2)</option>
                        <option value="Store Attdt">Store Attendant (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Accounts'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Exec Acct" selected>Executive Officer (Accounts) (CONTISS 6)</option>
                        <option value="Assist Exec Acct">Assistant Executive Officer (Accounts) (CONTISS 5)</option>
                        <option value="Snr Acct">Senior Accounts Clerk (CONTISS 4)</option>
                        <option value="Acct Clerk">Accounts Clerk (CONTISS 3)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Catering'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Catering" selected>Catering Officer (CONTISS 6)</option>
                        <option value="Assist Catering">Assistant Catering Officer (CONTISS 5)</option>
                        <option value="Snr Cook">Senior Cook/Steward (CONTISS 4)</option>
                        <option value="Head Cook">Head Cook/Steward (CONTISS 3)</option>
                        <option value="Assist Cook">Assist Cook/Steward (CONTISS 2)</option>
                        <option value="Kitchen">Kitchen Attendant (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Halls'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Prem" selected>Premises Officer/House Keeper (CONTISS 6)</option>
                        <option value="Chief Porter">Chief Porter (CONTISS 5)</option>
                        <option value="Head Porter">Head Porter (CONTISS 4)</option>
                        <option value="Snr Porter">Senior Porter (CONTISS 3)</option>
                        <option value="Porter">Porter (CONTISS 2)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Health'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Comm" selected>Community Health/Pharmacy/Medical Laboratory/Medical Records/X-ray Technicians (CONTISS 9)</option>
                        <option value="Assist Med Rec">Assistant Medical Records Officer (CONTISS 11)</option>
                        <option value="Snr Med Rec">Senior Medical Records Clerk (CONTISS 4)</option>
                        <option value="Med Rec">Medical Records Clerk (CONTISS 3)</option>
                        <option value="Assist Med Rec Clerk">Assistant Medical Records Clerk (CONTISS 2)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Pharmacy'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Principal Pharm Assist" selected>Principal Pharmacy Assistant (CONTISS 6)</option>
                        <option value="Snr Pharm Assist">Senior Pharmacy Assistant (CONTISS 5)</option>
                        <option value="Pharm Assist">Pharmacy Assistant (CONTISS 4)</option>
                        <option value="Pharm Assist In-Training">Pharmacy Assistant In-Training (CONTISS 3)</option>
                        <option value="Head Pharm Attdt">Head Pharmacy Attendant (CONTISS 2)</option>
                        <option value="Pharm Attdt">Pharmacy Attendant (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Health Assistant'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Health Sup">Health Superintendent (CONTISS 6)</option>
                        <option value="Assist Health Sup">Assitant Health Superintendent (Laboratory, X-Ray, Sanitary, Nursing) (CONTISS 5)</option>
                        <option value="Snr Health Assist">Senior Health Assistant (Laboratory, X-Ray, Sanitary, Nursing) (CONTISS 4)</option>
                        <option value="Health Assist">Health Assistant (CONTISS 3)</option>
                        <option value="Head Health Attdt">Head Health Attendant (CONTISS 2)</option>
                        <option value="Health Attdt">Health Attendant (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Washerman'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Head Washer">Head Washer-man (CONTISS 3)</option>
                        <option value="Snr Washer">Senior Washer-man (CONTISS 2)</option>
                        <option value="Washer">Washer-man (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Library'"
                        id="presentStatus" name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Lib Off">Library Officer (CONTISS 6)</option>
                        <option value="Senior Lib Assist">Senior Library Assistant (CONTISS 5)</option>
                        <option value="High Lib Assist">Higher Library Assistant (CONTISS 4)</option>
                        <option value="Lib Assist">Library Assistant (CONTISS 3)</option>
                        <option value="Head Lib Attdt">Head Library Attendant (CONTISS 2)</option>
                        <option value="Lib Attdt">Library Attendant (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Bindery'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Bind">Bindery/Printing Officer (CONTISS 6)</option>
                        <option value="Snr Bind">Senior Bindery/Printing Assistant (CONTISS 5)</option>
                        <option value="High Bind">Higher Bindery/Printing Assistant (CONTISS 4)</option>
                        <option value="Bind Assist"> Bindery/Printing Assistant (CONTISS 3)</option>
                        <option value="Snr Bind Attdt">Senior Bindery/Printing Attendant (CONTISS 2)</option>
                        <option value="Bind Attdt">Bindery/Printing Attendant (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Audio'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Tech Audio">Technical Officer (Audio Visual) (CONTISS 6)</option>
                        <option value="Audio Vis Assist">Ausio Visual Assistant (CONTISS 5)</option>
                        <option value="High Audio Attdt">Higher Audio-Visual Attendant (CONTISS 4)</option>
                        <option value="Audio Attdt">Audio-Visual Attendant (CONTISS 3)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Security'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Assist Sec">Assistant Security Officer (CONTISS 6)</option>
                        <option value="Pat Sup">Patrol Supervisor (CONTISS 5)</option>
                        <option value="Chief Pat">Chief Patrolman (CONTISS 4)</option>
                        <option value="Snr Pat">Senior Patrolman (CONTISS 3)</option>
                        <option value="Pat">Patrolman (CONTISS 2)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Environmental'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Draught">Technical Officer (Draughting) (CONTISS 6)</option>
                        <option value="Assist Draught">Assistant Technical Officer (Draughting)  (CONTISS 5)</option>
                        <option value="Snr Draught">Senior Technical Assitant (Draughting) (CONTISS 4)</option>
                        <option value="Tech Assist Draught">Technical Assistant (Draughting) (CONTISS 3)</option>
                        <option value="Head Tech Attdt">Head Technical Attendant (Drawing Room) (CONTISS 2)</option>
                        <option value="Tech Attdt">Technical Attendant (Drawing room) (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Engineering'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Tech 2">Technical Officer/Superintendent/Deputy Chief Technical Assistant II (CONTISS 6)</option>
                        <option value="Assist Tech">Asst. Tech. Officer (Eng. Lab or Workshop) (CONTISS 5)</option>
                        <option value="Snr Tech">Senior Tech. Asst. (Eng. Lab or Workshop) (CONTISS 4)
                        </option>
                        <option value="Tech Assist">Technical Assistant (Lab or Workshop) (CONTISS 3)</option>
                        <option value="Head Tech Attdt Lab">Head Tech. Attendant (Lab or Workshop) (CONTISS 2)</option>
                        <option value="Tech Attdt Lab">Technical Attendant (Lab or Workshop) (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Marine'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Snr River Master">Senior River Master</option>
                        <option value="River Master">River Master (CONTISS 5)</option>
                        <option value="Quarter Master">Quarter Master (CONTISS 4)</option>
                        <option value="Marine Engineering Assist">Marine Engineering Assistant (CONTISS 3)</option>
                        <option value="Able Seaman">Able Seaman (CONTISS 2)</option>
                        <option value="Attdt">Attendant (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Estate'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Head Labour">Head Labourer/Head Gardener (CONTISS 3)</option>
                        <option value="Labour 1">Labourer I/Gardener I (CONTISS 2)</option>
                        <option value="Labour 2">Labourer II/Gardener II (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Technical'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Technical">Technical Officer (CONTISS 6)</option>
                        <option value="Assist Technical">Assistant Technical Officer (Carpentry, Masonry etc Painting, Welding, Mechanical, Eleectrical, Plant Operator) (CONTISS 5)</option>
                        <option value="Technical Assist">Technical Assistant (Carpentry, Masonry etc Painting, Welding, Mechanical, Electrical, Plant Operator) (CONTISS 4)</option>
                        <option value="Technical Assist 2">Technical Assistant II (Carpentry, Masonry, Painting, Welding, Mechanical, Electrical, Plant Operator) (CONTISS 9)</option>
                        <option value="Head Technical Attdt">Head Technical Attendant (CONTISS 2)</option>
                        <option value="Technical Attdt">Technical Attendant (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Drivers'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Trans Sup">Transport Supervisor/Workshop Supervisor (Mechanic or Plant) (CONTISS 6)</option>
                        <option value="Chief Motor">Chief Motor Driver (CONTISS 5)</option>
                        <option value="Head Motor">Head Motor Driver (CONTISS 4)
                        </option>
                        <option value="Snr Motor">Senior Motor Driver (CONTISS 3)</option>
                        <option value="Motor">Motor Driver (CONTISS 2)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Drivers Mater'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Head Mate">Head Driver's Mate (CONTISS 3)</option>
                        <option value="Driver Mate 1">Drivers Mate I (CONTISS 2)</option>
                        <option value="Driver Mate 2">Drivers Mater II (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Tractor'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Tractor Trans Sup">Transport Supervisor/Workshop Supervisor (Mechanic or Plant) (CONTISS 6)</option>
                        <option value="Chief Tractor Driver">Chief Tractor Driver (CONTISS 5)</option>
                        <option value="Head Tractor Driver">Head Tractor Driver (CONTISS 4)</option>
                        <option value="Snr Tractor Driver">Senior Tractor Driver (CONTISS 3)</option>
                        <option value="Tractor Driver">Tractor Driver (CONTISS 2)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Stores'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Stores Officer">Stores Officer (CONTISS 6)</option>
                        <option value="Store Keeper 1">Store Keeper I (CONTISS 5)</option>
                        <option value="Store Keeper 2">Store Keeper II (CONTISS 4)</option>
                        <option value="Store Clerk">Store Clerk (CONTISS 3)</option>
                        <option value="Store Assist">Store Assistant (CONTISS 2)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Store Attendant'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Head Store Attdt">Head Store Attendant (CONTISS 3)</option>
                        <option value="Store Attdt 1">Store Attendant I (CONTISS 2)</option>
                        <option value="Store Attdt 2">Store Attendant II (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Agriculture'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Agric Tech">Technical Officer (Livestock, Fisheries, Agric, Crop etc) (CONTISS 6)</option>
                        <option value="Assit Agric Tech">Asistant Technical Officer (Livestock, Fisheries, Agric, Crop etc) (CONTISS 5)</option>
                        <option value="Snr Agric Tech Assist">Senior Technical Assistant (Livestock, Nurseryman, Gardening, Fisheries, Abbattoir, etc.) (CONTISS 4)</option>
                        <option value="Agric Tech Assist">Technical Assistant (Livestock, Nurseryman, Gardening, Fisheries, Abattoir, etc) (CONTISS 3)</option>
                        <option value="Head Agric Tech Attdt">Head, Technical Attendant (CONTISS 2)</option>
                        <option value="Agric Tech Attdt">Technical Attendant (Farm, Feed-mill, Herdsman) (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Labourer'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Head Labourer">Head Labourer (CONTISS 3)</option>
                        <option value="Labourer 1">Labourer I (CONTISS 2)</option>
                        <option value="Labourer 2">Labourer II (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Science'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Lab Techn">Laboratory Technician (CONTISS 6)</option>
                        <option value="Assist Lab Techn">Assistant Laboratory Technician (CONTISS 5)</option>
                        <option value="Snr Lab Assit">Senior Laboratory Assistant (CONTISS 4)</option>
                        <option value="Lab Assist">Laboratory Assistant (CONTISS 3)</option>
                        <option value="Head Lab Attdt">Head Laboratory Attendant (CONTISS 2)</option>
                        <option value="Lab Attdt">Laboratory Attendant (CONTISS 1)</option>
                    </select>
                    <select v-if="staffType == 'Junior Non-academic' && staffCadre == 'Nursery'" id="presentStatus"
                        name="presentStatus" v-model="presentStatus" style="width: 250px;">
                        <option value="Head Nurs">Head Nursery (CONTISS 6)</option>
                        <option value="Snr Nurs Attdt">Senior Nursery Attendant (CONTISS
                            5)</option>
                        <option value="Nurs Attdt 1">Nursery Attendant I (CONTISS 4)</option>
                        <option value="Nurs Attdt 2">Nursery Attendant II (CONTISS 3)</option>
                        <option value="Nurs Attdt 3">Nursery Attendant III (CONTISS 2)</option>
                        <option value="Training Nurs Attdt">Nursery Attendant-In-Training (CONTISS 1)</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="mb-4">
            <div>
                <p class="mb-0"><b>8. &nbsp; &nbsp;Present Unit:</b></p>
            </div>
            <div>
                <input type="text" class="form-control pb-0" name="presentUnit" v-model="presentUnit">
            </div>
        </div>

        <div class="mb-4">
            <div>
                <p class="mb-0"><b>9. &nbsp; &nbsp;Date, Status and Level of first appointment in this University:</b></p>
            </div>
            <div>
                <input type="text" class="form-control pb-0" name="firstEmployment" v-model="firstEmployment" placeholder="e.g. 18 October 2019, Administrative Officer I, CONTISS 8">
            </div>
        </div>

        <!-- first employment -->
        <div class="mb-4">
            <div>
                <p class="mb-0"><b>10. &nbsp; &nbsp;Last change in status with date:</b></p>
            </div>
            <div>
                <textarea v-model="lastEmployment" type="text" class="form-control pb-0" placeholder="e.g. Administrative Officer I, 18 October 2019"></textarea>
            </div>
        </div>

        <div class="mb-4">
            <div>
                <p class="mb-0"><b>11. &nbsp; &nbsp;Date of confirmation of appointment:</b></p>
            </div>
            <div>
                <input v-model="confirmationDate" type="text" class="form-control picker" id="confirmationDate"
                    aria-describedby="emailHelp" placeholder="e.g. 23rd October, 2021" required>
            </div>
        </div>

        <!-- qualifications -->
        <div class="mb-4 text-start">
            <div>
                <b>
                    12. &nbsp; &nbsp;Qualifications:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#qualification"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=qualificationsCert :type='"qualificationsCert"' />
        </div>



        <!-- qualifications modal -->
        <div class="modal fade" id="qualification" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="qualificationLabel">Qualifications</h1>
                        <button id="closeQualifications" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="bookChapter" class="form-label">Qualification Details:</label>
                            <span>
                                <textarea rows="4" v-model="qualification" type="text" class="form-control"
                                    id="qualificationsCert" placeholder="e.g. B.Sc. in Office And Information Management, (2017–2020), Rivers State University, Port Harcourt, Nigeria."></textarea>
                            </span>
                            <br>
                            <div>
                                <label for="qualificationsCertUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="qualificationsCertUrl" type="text" class="form-control" id="qualificationsCertUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('qualification')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-4 text-start" v-if="staffType == 'Senior Non-academic'">
            <div>
                <div class="d-flex mb-3">
                    <b>
                        13. &nbsp; &nbsp;Membership of professional bodies (State whether membership by examination):
                    </b>
                    <span @click="resetEdit()" class="ms-3">
                        <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#professionalBody"><i class="fa fa-plus" aria-hidden="true"></i></button>
                    </span>
                </div>
                <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=professionalBodies :type='"professionalBodies"' />
            </div>
        </div>

        <!-- professional body Modal -->
        <div class="modal fade" id="professionalBody" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel12">Professional Body Membership</h1>
                        <button id="closeProfessionals" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3 mx-4 text-start">
                            <label for="exampleFormControlInput124" class="form-label me-3">Membership Details:</label>
                            <textarea rows="4" v-model="professionalBody" type="text" class="form-control"
                                id="exampleFormControlInput4" placeholder="e.g. Since 2024, Member of the Nigerian Institute of Management."></textarea>
                            <br>
                            <div>
                                <label for="professionalBodyUrl" class="form-label">Certificate Google Drive Link:</label>
                                <input v-model="professionalBodyUrl" type="text" class="form-control" id="professionalBodyUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('professionalBody')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-4 text-start">
            <div>
                <div class="d-flex mb-3">
                    <b>
                        <span v-if="staffType == 'Senior Non-academic'">14.</span>
                        <span v-if="staffType == 'Junior Non-academic'">13.</span>
                        &nbsp; &nbsp;Post-qualification experience before joining this University (State employers,
                        post, dates)
                    </b>
                    <span @click="resetEdit()" class="ms-3">
                        <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#postQualification"><i class="fa fa-plus" aria-hidden="true"></i></button>
                    </span>
                </div>
                <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=postQualifications :type='"postQualifications"' />
            </div>
        </div>

        <!-- Post qualification Modal -->
        <div class="modal fade" id="postQualification" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel12">Post Qualification</h1>
                        <button id="closePostQualification" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3 mx-4 text-start">
                            <label for="postQualification" class="form-label me-3">Post Qualification Details:</label>
                            <textarea rows="5" v-model="postQualification" type="text" class="form-control"
                                id="postQualification" placeholder="e.g. In January 2014; Nigeria Engineering Works Ltd. (NEWCLIME): Worked as an intern in the Human Resources Department of Nigeria Engineering Works Ltd."></textarea>
                            <br>
                            <div>
                                <label for="postQualificationUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="postQualificationUrl" type="text" class="form-control" id="postQualificationUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('postQualification')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-4 text-start">
            <div>
                <div class="d-flex mb-3">
                    <b>
                        <span v-if="staffType == 'Senior Non-academic'">15.</span>
                        <span v-if="staffType == 'Junior Non-academic'">14.</span>
                        &nbsp; &nbsp;In-Service Training attended since appointment/last promotion/regarding
                        (specify) with date:
                    </b>
                    <span @click="resetEdit()" class="ms-3">
                        <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#inServiceTraining"><i class="fa fa-plus" aria-hidden="true"></i></button>
                    </span>
                </div>
                <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=inServiceTrainings :type='"inServiceTrainings"' />
            </div>
        </div>

        <!-- Inservice training Modal -->
        <div class="modal fade" id="inServiceTraining" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel12">In-Service Training</h1>
                        <button id="closeTraining" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3 mx-4 text-start">
                            <label for="inServiceTraining" class="form-label me-3">In-Service Training Details:</label>
                            <textarea rows="4" v-model="inServiceTraining" type="text" class="form-control"
                                id="inServiceTraining" placeholder="e.g. On 5 February 2024, attended the “Orientation for Newly Employed Academic and Non-teaching staff of the University” organised by Rivers State University, Port Harcourt, Nigeria."></textarea>
                            <br>
                            <div>
                                <label for="inServiceTrainingUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="inServiceTrainingUrl" type="text" class="form-control" id="inServiceTrainingUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('inServiceTraining')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-row-reverse py-5">
            <button @click="saveSection()" type="button" class="btn btn-success me-3">Save & Continue</button>
        </div>
    </div>
    </div>
</Transition>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'section1',
    emits: ['toggleLoader', 'setSection', 'submitted'],
    data() {
        return {
            name: '',
            fileNum: '',
            phoneNum: '',
            faculty: 'Others',
            staffCadre: '',
            staffType: '',
            presentStatus: '',
            presentUnit: '',
            firstEmployment: '',
            lastEmployment: '',
            confirmationDate: '',
            qualification: '',
            qualificationsCertUrl: '',
            qualificationsCert: [],
            postQualification: '',
            postQualificationUrl: '',
            postQualifications: [],
            inServiceTraining: '',
            inServiceTrainingUrl: '',
            inServiceTrainings: [],
            professionalBody: '',
            professionalBodyUrl: '',
            professionalBodies: [],
            itemDeleteIndex: '',
            candidate: {},
            key: 0
        }
    },
    created() {
        this.$emit('setSection', 'Section I');
        this.setData()
    },
    methods: {
        resetEdit(){
            //removes edit section if present on the page
            for (var i=0; i < this.qualificationsCert.length; i++) {
                this.qualificationsCert[i].editing = false
            }
            for (var i=0; i < this.postQualifications.length; i++) {
                this.postQualifications[i].editing = false
            }
            for (var i=0; i < this.inServiceTrainings.length; i++) {
                this.inServiceTrainings[i].editing = false
            }
            for (var i=0; i < this.professionalBodies.length; i++) {
                this.professionalBodies[i].editing = false
            }
        },
        async joinDetails(category) {
            this.$emit('toggleLoader');

            if (category == 'qualification') {
               if (this.qualification) {
                    this.qualificationsCert.unshift({data: this.qualification, fileUrl: !/^https?:\/\//i.test(this.qualificationsCertUrl) ? this.qualificationsCertUrl ? "https://" + this.qualificationsCertUrl : '' : this.qualificationsCertUrl});
                    document.getElementById('closeQualifications').click();
               } else {
                    alert('Fill qualification details')
               }
               this.qualification = '';
               this.qualificationsCertUrl = '';
            }

            if (category == 'professionalBody') {
                if (this.professionalBody) {
                    this.professionalBodies.unshift({ data: this.professionalBody, fileUrl: !/^https?:\/\//i.test(this.professionalBodyUrl) ? this.professionalBodyUrl ? "https://" + this.professionalBodyUrl : '' : this.professionalBodyUrl });
                    document.getElementById('closeProfessionals').click();
                } else {
                    alert('Fill professional body details')
                }
                this.professionalBody = '';
                this.professionalBodyUrl = '';
            }

            if (category == 'postQualification') {
                if (this.postQualification) {
                    this.postQualifications.unshift({ data: this.postQualification, fileUrl: !/^https?:\/\//i.test(this.postQualificationUrl) ? this.postQualificationUrl ? "https://" + this.postQualificationUrl : '' : this.postQualificationUrl });
                    document.getElementById('closePostQualification').click();
                } else {
                    alert('Fill post qualification details')
                }
                this.postQualification = '';
                this.postQualificationUrl = '';
            }

            if (category == 'inServiceTraining') {
                if (this.inServiceTraining) {
                    this.inServiceTrainings.unshift({ data: this.inServiceTraining, fileUrl: !/^https?:\/\//i.test(this.inServiceTrainingUrl) ? this.inServiceTrainingUrl ? "https://" + this.inServiceTrainingUrl : '' : this.inServiceTrainingUrl });
                    document.getElementById('closeTraining').click();
                } else {
                    alert('Fill in-service training details')
                }
                this.inServiceTraining = '';
                this.inServiceTrainingUrl = '';
            }

            this.key += 1;
            this.$emit('toggleLoader');
        },
        async updateStaffType() {
            this.$emit('toggleLoader');

            var dataDetails = {
                staffType: this.staffType
            }

            const user = await DataService.saveData(dataDetails)

            this.$emit('toggleLoader');

            if (user) {
                var token = JSON.parse(window.localStorage['user']).token
                this.$store.commit('connect', {_id: user._id, staffType: user.staffType, token: token});

                if (user.staffType == 'Academic Teaching' || user.staffType == 'Research' || user.staffType == 'Library') {
                    this.$router.push({ path: '/sectiona' });
                } else {
                    this.$router.push({ path: '/section1' })
                }
            }
        },
        async saveSection() {
            this.$emit('toggleLoader');

            var dataDetails = {
                name: this.name,
                fileNum: this.fileNum,
                faculty: this.faculty,
                phoneNum: this.phoneNum,
                staffCadre: this.staffCadre,
                staffType: this.staffType,
                department: this.presentUnit,
                presentStatus: this.presentStatus,
                firstEmployment: this.firstEmployment,
                lastEmployment: this.lastEmployment,
                confirmationDate: this.confirmationDate,
                otherQualifications: this.qualificationsCert,
                postQualifications: this.postQualifications,
                inServiceTrainings: this.inServiceTrainings,
                professionalBodies: this.professionalBodies,
            }

            const candidate = await DataService.saveData(dataDetails)

            this.$emit('toggleLoader');

            if (candidate) {
                this.$router.push('/section2')
            }
        },
        async setData() {
            window.scrollTo({ top: 0, behavior: 'smooth' });

            this.$emit('toggleLoader');

            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id);

            if (candidate) {
                if ((candidate.staffType == "Academic Teaching") || (candidate.staffType == "Research") || (candidate.staffType == "Library")) {
                    this.$emit('toggleLoader');
                    this.$router.push({ path: `/sectiona` });
                    return
                }
                this.$emit('submitted', candidate.submitted);
                this.candidate = candidate
                this.name = candidate.name ? candidate.name : ''
                this.fileNum = candidate.fileNum ? candidate.fileNum : ''
                this.phoneNum = candidate.phoneNum ? candidate.phoneNum : '';
                this.faculty = candidate.faculty ? candidate.faculty : 'faculty';
                this.staffCadre = candidate.staffCadre ? candidate.staffCadre : '';
                this.staffType = candidate.staffType ? candidate.staffType : '';
                this.presentStatus = candidate.presentStatus ? candidate.presentStatus : '';
                this.presentUnit = candidate.department ? candidate.department : '';
                this.firstEmployment = candidate.firstEmployment ? candidate.firstEmployment : '';
                this.lastEmployment = candidate.lastEmployment ? candidate.lastEmployment : '';
                this.confirmationDate = candidate.confirmationDate ? candidate.confirmationDate : '';
                this.qualificationsCert = candidate.otherQualifications ? candidate.otherQualifications : [];
                this.professionalBodies = candidate.professionalBodies ? candidate.professionalBodies : [];
                this.postQualifications = candidate.nonacademicStaff ? candidate.nonacademicStaff.postQualifications ? candidate.nonacademicStaff.postQualifications : [] : [];
                this.inServiceTrainings = candidate.nonacademicStaff ? candidate.nonacademicStaff.inServiceTrainings ? candidate.nonacademicStaff.inServiceTrainings : [] : [];
                this.professionalBodies = candidate.professionalBodies ? candidate.professionalBodies : [];
                this.key += 1
            }

            this.$emit('toggleLoader');
        }
    }
}
</script>